import {
  ICON_TO_SVGS_FILLED_12,
  ICON_TO_SVGS_FILLED_16,
  ICON_TO_SVGS_FILLED_24,
  ICON_TO_SVGS_FILLED_32,
  ICON_TO_SVGS_OUTLINED_12,
  ICON_TO_SVGS_OUTLINED_16,
  ICON_TO_SVGS_OUTLINED_24,
  ICON_TO_SVGS_OUTLINED_32,
} from "@/src/easy-icons/constants/icons";

export enum IconSizes {
  XSmall = 6,
  Small = 12,
  Medium = 16,
  Large = 24,
  XLarge = 32,
}

export enum IconVariants {
  Full = "full",
  Outlined = "outlined",
}

export enum IconColors {
  Positive = "positive",
  Negative = "negative",
  Main = "main",
  Important = "important",
  Muted = "muted",
}

export enum IconActions {
  Plus = "plus",
  Remove = "remove",
}

export type IconNamesOutline12 = keyof typeof ICON_TO_SVGS_OUTLINED_12;

export type IconNamesFilled12 = keyof typeof ICON_TO_SVGS_FILLED_12;

export type IconNamesOutline16 = keyof typeof ICON_TO_SVGS_OUTLINED_16;

export type IconNamesFilled16 = keyof typeof ICON_TO_SVGS_FILLED_16;

export type IconNamesOutline24 = keyof typeof ICON_TO_SVGS_OUTLINED_24;

export type IconNamesFilled24 = keyof typeof ICON_TO_SVGS_FILLED_24;

export type IconNamesOutline32 = keyof typeof ICON_TO_SVGS_OUTLINED_32;

export type IconNamesFilled32 = keyof typeof ICON_TO_SVGS_FILLED_32;

export type IconNames =
  | IconNamesOutline12
  | IconNamesFilled12
  | IconNamesOutline16
  | IconNamesFilled16
  | IconNamesOutline24
  | IconNamesFilled24
  | IconNamesOutline32
  | IconNamesFilled32;

export interface IconMetadata {
  size: IconSizes;
  path: IconVariants;
  name: string;
}
